import "./Footer.css";
import FooterCard from "./FooterCard";
import FooterWatermark from "./FooterWaterMark";
import FooterCopyright from "./FooterCopyright";

export default function Footer() {
    return (
        <footer className="footer-wrapper">
            <FooterCard />
            <FooterWatermark />
            <FooterCopyright />
        </footer>
    );
}
